import React from "react";

import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';

const AccessPerMonth = (props) => {
    const { t } = useTranslation();

    const chartData = props.chartData;

    return (  
        <>
        {chartData &&
            <ReactApexChart
                options={{
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: chartData.dates,
                    },
                    yaxis: {
                        title: {
                            text: t('data-lang-charts-connectioncount')
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val + ((val === 1) ? t('data-lang-charts-connectionpartial-1') : t('data-lang-charts-connectionpartial-morethan-1'))
                            }
                        }
                    }
                }}

                series={[{
                    name: 'Client 1',
                    data: chartData.values,
                }]} type="bar" width="100%" height="200px"
            />
        }
        {!chartData && 
            <Shimmer
                customElementsGroup={
                  <Row style={{ display: 'flex' }}>
                    <Col>
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 50, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 170,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 120,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 150, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 150, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 50, height: 5,  verticalAlign: 'bottom' },
                        ]}
                    />
                    </Col>
                  </Row>
                }
                className="pt-4"
                isDataLoaded={chartData !== null}>
            </Shimmer>
        }
        </>
    );
};
AccessPerMonth.propTypes = {
    chartData: PropTypes.object.isRequired,
};
export default AccessPerMonth;